const ITEMS = [
  "AI DIET PLANS",
  "WORKOUT LOGGER",
  "WATER TRACKER",
  "VEG & NON-VEG",
  "PROGRESS TRACKING",
  "INDIAN MEALS",
];

export const Marquee = () => {
  const content = (
    <span className="flex items-center gap-4 text-black font-display text-xl sm:text-2xl uppercase px-4">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center gap-4">
          {item} <span className="text-black/40">•</span>
        </span>
      ))}
    </span>
  );
  return (
    <div data-testid="marquee-strip" className="bg-[#C6FF3D] py-4 overflow-hidden whitespace-nowrap">
      <div className="flex animate-forge-marquee w-max">
        {content}
        {content}
      </div>
    </div>
  );
};
